<template>
  <div>
    <div class="columns">
      <div class="column">
        <div class="title is-size-4">Избранное</div>
      </div>
      <div class="column is-narrow">
        <favourite-add-group>
          <b-button type="is-primary">
            <span class="icon">
              <i class="mdi mdi-plus-circle-outline"></i>
            </span>
            <span>Создать группу</span>
          </b-button>
        </favourite-add-group>
      </div>
    </div>

    <transition-group
      name="fade"
      tag="div"
      class="columns is-multiline is-mobile"
    >
      <favourite-card
        v-for="favouriteGroup in favouriteGroups"
        :key="favouriteGroup.name"
        :favouriteGroup="favouriteGroup"
        class="column is-one-third"
      ></favourite-card>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Favourites",
  components: {
    FavouriteCard: () =>
      import(
        /* webpackChunkName: "FavouriteCard" */ "@/components/user/favourites/FavouriteCard.vue"
      ),
    FavouriteAddGroup: () =>
      import(
        /* webpackChunkName: "FavouriteAddGroup" */ "@/components/user/favourites/FavouriteAddGroup.vue"
      )
  },
  computed: {
    ...mapGetters("favourites", {
      favouriteGroups: "favouriteGroups"
    })
  }
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
